import {createTheme} from "@mui/material";

const theme = createTheme({
    palette:{
        warning: {
            main: "#FFA726",
            dark: "#FB8C00",
        },
    }
});

export default theme;